import(/* webpackMode: "eager" */ "/vercel/path0/app/tutoriel/page.tsx");
